module.exports = __webpack_public_path__ + "img/logo-footer.31c32443.svg";